module.exports = __webpack_public_path__ + "static/media/gift4.61894e6c.jpg";